<template>
  <div id="app">
    <router-view/>
    <div v-if="$route.meta.tabbar" class="tabber_placeholder"></div>
    <van-tabbar v-if="$route.meta.tabbar" v-model="active" active-color="#cf2f04" inactive-color="#868686" safe-area-inset-bottom @change="onChange">
      <van-tabbar-item>
        <span>规则</span>
        <template #icon="props">
          <div class="tabber_icon tabber_rule" :class="{active:props.active}"></div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>上传</span>
        <template #icon="props">
          <div class="tabber_icon tabber_upload" :class="{active:props.active}"></div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>我的</span>
        <template #icon="props">
          <div class="tabber_icon tabber_center" :class="{active:props.active}"></div>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>

let that;
import {Tabbar, TabbarItem, Dialog, Toast} from 'vant';
export default {
  name: 'App',
  components:{
    'van-tabbar':Tabbar,
    'van-tabbar-item':TabbarItem,
  },
  data() {
    return {
      active: 0,
      full_hei:false,
      tip_id:null
    };
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      // console.log(to,from);
      switch (to.name){
        case 'Upload':this.active=1;break
        case 'Center':this.active=2;break;
        default:this.active=0;
      }
    }
  },
  created() {
    that=this;

    let cont_hei=1440*window.innerWidth / 750;
    this.full_hei=cont_hei<window.innerHeight;
    // console.log(window.innerHeight,1440*window.innerWidth / 750);
  },
  methods:{
    onChange(index) {
      const map = { 0: 'rule.html', 1: 'upload.html', 2: 'center.html' };
      const target = map[index];
      const path = `${this.$prefix || '/'}${target}`;

      // 只有路径不同时才跳转，防止重复跳转报错
      if (this.$route.path !== path) {
        this.$router.replace(path).catch(() => {});
      }
    },
    getNotice() {
      this.$http.post('getNotice').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        if(res.code===200){
          // that.tip_id=res.tip_id;
          Dialog.alert({
            title: '通知',
            message: res.msg,
          }).then(() => {
            // on close
            that.readNotice(res.data.tip_id)
          });

        }
      }).catch(function (error) {
        console.log(error);
      })
    },
    readNotice(tip_id) {
      this.$http.post('readNotice',{tip_id:tip_id}).then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        /*if(res.status==1){
        }*/
        Toast(res.msg);
      }).catch(function (error) {
        console.log(error);
      })
    },
  }
}
</script>

<style>
:root {
  --index_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/index_bg.png?v=1");
  --btn_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/btn_bg.png?v=1");
  --index_tit: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/index_tit.png?v=1");
  --logo: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/logo.png?v=1");
  --login_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/login_bg.png?v=1");
  --icon_tabbar_rule: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_rule.png?v=1");
  --icon_tabbar_rule_active: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_rule_active.png?v=1");
  --icon_tabbar_upload: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_upload.png?v=1");
  --icon_tabbar_upload_active: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_upload_active.png?v=1");
  --icon_tabbar_center: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_center.png?v=1");
  --icon_tabbar_center_active: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_tabbar_center_active.png?v=1");
  --rule_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/rule_bg.png?v=1");
  --rule_tit: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/rule_tit.png?v=1");
  --rule_txt: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/rule_txt.png?v=2");
  --icon_rule: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_rule.png?v=1");
  --upload_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_bg.png?v=1");
  --upload_tit: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_tit.png?v=1");
  --upload_img_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_img_bg.png?v=1");
  --upload_btn_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_btn_bg.png?v=1");
  --upload_icon_select: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/icon_select.png?v=1");
  --upload_suc: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/upload_suc.png?v=1");
  --center_bg: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/center_bg.png?v=1");
  --center_icon_weight: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/center_icon_weight.png?v=1");
  --center_icon_clear: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/center_icon_clear.png?v=1");
  --center_suc: url("https://h5storage.xingflash.com/grcbank_sports_score_2025/images/center_suc.png?v=1");
}
#app{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.logo{
  background: var(--logo) no-repeat left bottom;
  background-size: 100% auto;
  width: 235rem;
  height: 65rem;
  position: absolute;
  top: 99rem;
  left: 70rem;
}
.btn{
  background: var(--btn_bg) no-repeat left bottom;
  background-size: 100% auto;
  width: 443rem;
  height: 69rem;
  line-height: 69rem;
  color: #e42f04;
  font-size: 34rem;
  text-align: center;
  font-weight: bold;
}
img{
  display: block;
}
.tabber_placeholder{
  display: block;
  width: 100%;
  height: 50px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
}
.tabber_icon{
  width: 50rem;
  height: 50rem;
}
.tabber_rule{
  background: var(--icon_tabbar_rule) no-repeat center;
  background-size: 36rem auto;
}
.tabber_rule.active{
  background: var(--icon_tabbar_rule_active) no-repeat center;
  background-size: 36rem auto;
}
.tabber_upload{
  background: var(--icon_tabbar_upload) no-repeat center;
  background-size: 57rem auto;
}
.tabber_upload.active{
  background: var(--icon_tabbar_upload_active) no-repeat center;
  background-size: 57rem auto;
}
.tabber_center{
  background: var(--icon_tabbar_center) no-repeat center;
  background-size: 41rem auto;
}
.tabber_center.active{
  background: var(--icon_tabbar_center_active) no-repeat center;
  background-size: 41rem auto;
}
</style>
